export enum CompanyAdminStatus {
  Has = "Has",
  DoesntHave = "Doesn't have"
}
